"use strict";

/**
 * OverlayIds
 */
export default {
    ALL: 'ALL',
    CHECKOUT: 'CHECKOUT',
    PAYMENT_METHOD: 'PAYMENT_METHOD',
    CVV_INFO: 'CVV_INFO',
    PREORDERED_ITEM: 'PREORDERED_ITEM',
    /** Virgin sunset migration mock overlays (PDF Web 9 / 10 / 11) */
    MIGRATION_COMPLETE_WEB9: 'MIGRATION_COMPLETE_WEB9',
    MIGRATION_FAILED_WEB10: 'MIGRATION_FAILED_WEB10',
    MIGRATION_ATTEMPT_MULTIPLE_FAILED_WEB11: 'MIGRATION_ATTEMPT_MULTIPLE_FAILED_WEB11',
};
